export enum Stage {
  test = "test",
  alpha = "alpha",
  beta = "beta",
  prod = "prod",
}

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
}

/**
 * Enum for holding possible states of an API call.
 */
export enum APICallStatus {
  NOT_STARTED, IN_PROGRESS, SUCCESSFUL, FAILED,COMPLETED
}

/**
 * Enum for holding status of an event model.
 * This status determines if the event model will be processed by EASE ExecuteEvents API.
 */
export enum EventModelStatus {
  DRAFT = "DRAFT",
  LIVE = "LIVE",
  RETIRED = "RETIRED",
}
